"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchBarSize = exports.classes = exports.spinnerSize = exports.mediumBtn = exports.textOnlyBtn = exports.typographyCaption = exports.noDataText = exports.nextDataButtonText = void 0;
var nextDataButtonText = 'Load More...';
exports.nextDataButtonText = nextDataButtonText;
var noDataText = 'No data available';
exports.noDataText = noDataText;
var typographyCaption = 'caption1';
exports.typographyCaption = typographyCaption;
var textOnlyBtn = 'textOnly';
exports.textOnlyBtn = textOnlyBtn;
var mediumBtn = 'medium';
exports.mediumBtn = mediumBtn;
var spinnerSize = 'medium';
exports.spinnerSize = spinnerSize;
var classes = {
  dataTableWrapper: 'vault-data-table-wrapper',
  dataTableBottomPanel: 'vault-data-table-bottom-panel',
  searchContainer: 'data-table-search-container',
  noBorder: 'no-border'
};
exports.classes = classes;
var searchBarSize = '400px';
exports.searchBarSize = searchBarSize;